import React from "react";
import StepCompleteActionButton from "./StepCompleteActionButton";

const UploadSignedDocumentControls = ({
    onUploadFile,
    onTakePicture
}) => {
    return (
        <div className="text-center mt-2">

            <label
                style={{
                    width: "100%",
                    maxWidth: 400,
                    padding: "1rem",
                    borderRadius: 12,
                    textAlign: "center",
                    background: "linear-gradient(145deg, #ffffff, #f0f0f0)",
                    boxShadow:
                        "4px 4px 12px rgba(0,0,0,0.12), -4px -4px 12px rgba(255,255,255,0.8)",
                    fontSize: "1.1rem",
                    fontWeight: 600,
                    color: "#333",
                    cursor: "pointer",
                    transition: "all 0.2s ease"
                }}
                onMouseEnter={(e) => {
                    e.target.style.transform = "translateY(-2px)";
                    e.target.style.boxShadow =
                        "6px 6px 16px rgba(0,0,0,0.15), -6px -6px 16px rgba(255,255,255,0.9)";
                }}
                onMouseLeave={(e) => {
                    e.target.style.transform = "translateY(0)";
                    e.target.style.boxShadow =
                        "4px 4px 12px rgba(0,0,0,0.12), -4px -4px 12px rgba(255,255,255,0.8)";
                }}
            >
                Upload Signed Document
                <input
                    type="file"
                    accept="*"
                    onChange={onUploadFile}
                    style={{ display: "none" }}
                />
            </label>

            <h1 className="text-dark fw-semibold">OR</h1>

            <StepCompleteActionButton
                label="TAKE A PICTURE"
                onClick={onTakePicture}
            />
        </div>
    );
};

export default UploadSignedDocumentControls;